import React from 'react'
import '../assets/css/AdHocMultipleAddsModal.css';
import Button from '../DMGComponents/Button'
import EmailAddressesTextArea from './EmailAddressesTextArea'

class AdHocAddMultipleUsers extends React.Component {
    constructor(props) {
        super(props);
        this._emailTextArea = React.createRef();
        this.state = {
            validEmails: [],
            hasInvalidEmails: false,
        }
    }

    addUsers = () => {  
        this.handleClose();
        if (typeof this.props.addMultipleUsers === 'function') {
            this.props.addMultipleUsers(this.state.validEmails);
        }
    }

    handleClose = () => {
        this.setState({
            validEmails: [],
            hasInvalidEmails: false
        }, () => {
            this._emailTextArea.current.handleClose();
            if (typeof this.props.handleClose === 'function') {
                this.props.handleClose();
            }
        });
    }

    updateValidEmails = (validEmails) => {
        this.setState({
            validEmails: validEmails
        });
    }

    updateInvalidEmails = (hasInvalidEmails) => {
        this.setState({
            hasInvalidEmails: hasInvalidEmails
        });
    }

    render() {
        const showHideClassName = this.props.show ? "ahModal display-block" : "ahModal display-none";
        return (
            <div className={showHideClassName}>
                <section className="ahModal-main">
                    <div className="ahModal-buttons">
                        <span style={{ marginRight: "12px" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.addUsers() }} disabled={!(this.state.validEmails.length > 0 && !this.state.hasInvalidEmails) } >Add users</Button>
                        </span>
                        <Button type="hover-bottom-left" onClick={() => {  this.handleClose() }}>Close</Button>
                    </div>
                    <div className="ahModal-emails">
                        <EmailAddressesTextArea updateValidEmails={this.updateValidEmails} updateInvalidEmails={this.updateInvalidEmails} ref={this._emailTextArea} />
                    </div>
                </section>
            </div>
        );
    }
};

export default AdHocAddMultipleUsers;